module.exports = __webpack_public_path__ + "static/media/LidlPro_Semi_Bold.e3a89ab6.woff2";